export const TAG_CREATE_INIT = 'TAG_CREATE_INIT';
export const TAG_CREATE = 'TAG_CREATE';

export const TAG_REMOVE_INIT = 'TAG_REMOVE_INIT';
export const TAG_REMOVE = 'TAG_REMOVE';

export const TAG_BULK_UPDATE = 'TAG_BULK_UPDATE';
export const TAG_BULK_UPDATE_INIT = 'TAG_BULK_UPDATE_INIT';
export const TAG_BULK_UPDATE_DONE = 'TAG_BULK_UPDATE_DONE';
